import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HomeEn from "../pages/home-en/page";
import HomeDe from "../pages/home-de/page";
import SpreadsheetPage from "../pages/spreadsheet/page";
import ReviewPage from "../pages/review/page";
import ShippingPage from "../pages/shipping/page";
import QcPage from "../pages/qc/page";
import GuidePage from "../pages/guide/page";
import SafetyPage from "../pages/safety/page";
import FaqPage from "../pages/faq/page";
import CategoriesPage from "../pages/categories/page";
import BeginnersArticle from "../pages/articles/beginners/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import DisclaimerPage from "../pages/disclaimer/page";
import PrivacyPage from "../pages/privacy/page";
import { pillarArticles } from "../mocks/pillarArticles";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <HomeEn />,
  },
  {
    path: "/de",
    element: <HomeDe />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <SpreadsheetPage />,
  },
  {
    path: "/cssbuy-review",
    element: <ReviewPage />,
  },
  {
    path: "/cssbuy-shipping",
    element: <ShippingPage />,
  },
  {
    path: "/cssbuy-qc",
    element: <QcPage />,
  },
  {
    path: "/cssbuy-guide",
    element: <GuidePage />,
  },
  {
    path: "/cssbuy-safety",
    element: <SafetyPage />,
  },
  {
    path: "/cssbuy-faq",
    element: <FaqPage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/cssbuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  ...pillarArticles.map((a) => ({
    path: `/${a.slug}`,
    element: <ArticlePage slug={a.slug} />,
  })),
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;